// Redux slice for toast notifications
const ADD_TOAST = 'toastNotifications/ADD_TOAST'
const REMOVE_TOAST = 'toastNotifications/REMOVE_TOAST'

export function addToast(toast) {
  return { type: ADD_TOAST, payload: toast }
}

export function removeToast(id) {
  return { type: REMOVE_TOAST, payload: id }
}

const initialState = []

export default function toastNotifications(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_TOAST:
      return [ ...state, action.payload ]
    case REMOVE_TOAST:
      return state.filter(t => t.id !== action.payload)
    default:
      return state
  }
}

export const selectors = {
  all: state => state.toastNotifications || []
}



// WEBPACK FOOTER //
// ./src/redux/toastNotifications.js